import { updateWhoVieWedmed } from "../../services/apis/dispense/updatewhoviewedmed";
import {
	getCurrentDateInAppTimezone,
	getCurrentDayInAppTimezone,
} from "../constants/timezone";

export function getCurrentDay() {
	return getCurrentDayInAppTimezone();
}

export const getPharmacyOrderDeliveryTime = () => {
	return getCurrentDateInAppTimezone();
}

export const DisplayCurrentDay = (setCurrentDate) => {
	const currentCanadaTime = getCurrentDay();
	setCurrentDate(currentCanadaTime)
}

export function getLocation(setCordinate) {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition((position) => showPosition(position, setCordinate));
	} else {
	}
}

function showPosition(position, setCordinate) {
	setCordinate({
		latitude: position.coords.latitude,
		longitude: position.coords.longitude
	});
}

export const getDefaultPharmacist = (pharmacyId, driverDefaultPharmacist) => {
	return driverDefaultPharmacist?.filter(item => item?.pharmacy_id === pharmacyId);
};

export const isPresentValue = (value) => (
	value !== undefined &&
	value !== null &&
	String(value).trim() !== ''
);

export const idsMatch = (firstId, secondId) => (
	isPresentValue(firstId) &&
	isPresentValue(secondId) &&
	String(firstId) === String(secondId)
);

export const findPharmacistById = (pharmacists, pharmacistId) => {
	if (!Array.isArray(pharmacists) || !isPresentValue(pharmacistId)) {
		return null;
	}

	return pharmacists.find((pharmacist) => idsMatch(pharmacist?.id, pharmacistId)) || null;
};

export const getPharmacistDisplayName = (pharmacist) => {
	const firstName = pharmacist?.name || '';
	const lastName = pharmacist?.last_name || '';
	const shouldAppendLastName = lastName && !firstName.toLowerCase().split(/\s+/).includes(lastName.toLowerCase());
	const displayName = [firstName, shouldAppendLastName ? lastName : ''].filter(Boolean).join(' ').trim();

	return displayName ? displayName.toUpperCase() : '';
};



export const handleToggleRXData = (
	index,
	data,
	openIndex,
	setOpenIndex,
	dispatch,
	clearSelectedPharmacistID,
	setSignatureErrors,
	setShowData,
	RemoveAllPatchesId,
	setPatientSignature,
	setShowComment,
	setShowPatientSignature,
	setShowPharmacistSignature,
	setPharmacistSignature,
	setComment,
	setIsPatientVerified,
	setPId,
	pharmacyId
) => {
	
	if (openIndex === index) {
		setOpenIndex(null);
		dispatch(clearSelectedPharmacistID(null));
	}

	else {
		setOpenIndex(index);
		dispatch(clearSelectedPharmacistID(null));
		setSignatureErrors((prevState) => ({
			...prevState,
			patientSign: null,
			pharmacistID: null,
			pharmacistSign: null,
		}));

		const requestedData = {
			pharmacy_id: pharmacyId,
			patient_id: data?.id
		}
		dispatch(updateWhoVieWedmed(requestedData))
	}

	setShowData(false);
	dispatch(RemoveAllPatchesId());
	setPatientSignature([null]);
	setShowPatientSignature(true);
	setShowPharmacistSignature(true);
	setPharmacistSignature(null);
	setShowComment(false);
	setComment("");
	setIsPatientVerified(true);

	setPId(data?.id);
	setTimeout(() => {
		const nextPatientCard = document.getElementById(`patientCard-${index}`);
		if (nextPatientCard) {
			nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}, 100);
};
